import { render } from "./deskBox.vue?vue&type=template&id=0f467dec&scoped=true"
import script from "./deskBox.vue?vue&type=script&lang=js"
export * from "./deskBox.vue?vue&type=script&lang=js"

import "./deskBox.vue?vue&type=style&index=0&id=0f467dec&lang=sass&scoped=true"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f467dec"]])

export default __exports__